import { clearPreAuthToken } from './tfa';

// Every logout path must call this. The session token and profile data live in localStorage,
// but a pending 2FA pre-auth token lives in sessionStorage, so localStorage.clear() alone left
// it behind (pentest review, PT-01/PT-07 frontend notes).
export const clearLocalSession = () => {
  localStorage.clear();
  clearPreAuthToken();
};
